const paths = ['/', '/about', '/project'];
const githubUsername = 'BenJeau';
const languageBlacklist = ['Objective-C', 'Ruby', 'C++', 'Batchfile', 'Shell', 'PowerShell', 'PLpgSQL'];
const repoBlacklist = ['BenJeau/SEG2505', 'BenJeau/seg2505_2018', 'BenJeau/ProductCatalog', 'https://github.com/CDH-Studio/react-native-calendar-kalend', 'BenJeau/cdh-website-external'];

export { paths, githubUsername, languageBlacklist, repoBlacklist };
